/* ─────────────────────────────────────────────
   Easter eggs. Small, discoverable, on-brand: rebellious about the bad press,
   never about getting high. Each one is a numbered block; delete any you don't want.
───────────────────────────────────────────── */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var say=function(m){if(window.tbgToast)window.tbgToast(m);};
  var burst=function(){if(window.tbgTrail)window.tbgTrail.burst();};

  /* 1. Console: for the curious. */
  try{
    console.log('%c\n   \\ | /\n  – TBG –     The Brothers Green\n   / | \\\n%c\n  You looked in the console. Respect.\n  Rule one still applies: notify Police and MPI before you plant.\n  Rule two: if you\'re reading this you probably grow things. hello@thebrothersgreen.co\n',
      'color:#EA7542;font-weight:700;font-family:monospace','color:#4C453F;font-family:monospace');
  }catch(e){}

  /* 2. Type "hemp" anywhere on the page: the seed trail scatters and settles. */
  var buf='';
  document.addEventListener('keydown',function(e){
    if(e.target&&/^(input|textarea|select)$/i.test(e.target.tagName))return;
    if(e.key.length!==1)return;
    buf=(buf+e.key.toLowerCase()).slice(-6);
    if(buf.slice(-4)==='hemp'){burst();say('Same plant we’ve been pressing since 2017. Still just a plant.');buf='';}
    if(buf.slice(-4)==='brad'){say('Brad says: go plant something.');buf='';}
  });

  /* 3. Tap the pouch five times: it spills. */
  var pouch=document.getElementById('hero-pouch'),taps=0,tapT;
  if(pouch){
    pouch.style.cursor='pointer';
    pouch.addEventListener('click',function(){
      taps++;clearTimeout(tapT);tapT=setTimeout(function(){taps=0;},1500);
      if(taps===5){taps=0;spill(pouch);say('Careful. That’s roughly 270 seeds you’ll never get back.');}
    });
  }
  function spill(from){
    if(reduce)return;
    var r=from.getBoundingClientRect(),n=42;
    var seedSvg=document.querySelector('#seed-trail symbol#seed');
    for(var i=0;i<n;i++){
      var s=document.createElementNS('http://www.w3.org/2000/svg','svg');
      s.setAttribute('viewBox','0 0 24 16');s.setAttribute('width',14+Math.random()*14);s.setAttribute('height',10+Math.random()*9);
      s.style.cssText='position:fixed;z-index:60;pointer-events:none;left:'+(r.left+r.width*0.3+Math.random()*r.width*0.4)+'px;top:'+(r.bottom-20)+'px;transform:rotate('+(Math.random()*360)+'deg)';
      s.innerHTML=seedSvg?seedSvg.innerHTML:'<ellipse cx="12" cy="8" rx="10" ry="6" fill="#D8C4A8" stroke="#4C453F"/>';
      document.body.appendChild(s);
      var dx=(Math.random()-.5)*260,dy=window.innerHeight-r.bottom+40+Math.random()*80,rot=(Math.random()-.5)*720,dur=1500+Math.random()*900;
      s.animate([{transform:'translate(0,0) rotate(0deg)',opacity:1},{transform:'translate('+dx*0.5+'px,'+dy*0.35+'px) rotate('+rot*0.5+'deg)',opacity:1,offset:.45},{transform:'translate('+dx+'px,'+dy+'px) rotate('+rot+'deg)',opacity:0}],{duration:dur,delay:Math.random()*320,easing:'cubic-bezier(.3,.6,.6,1)',fill:'both'});
      setTimeout(function(el){return function(){el.remove();};}(s),dur+400);
    }
  }

  /* 5. Hover the word "free" in the headline. */
  var free=document.querySelector('.hero h1 .x-o');
  if(free)free.title='Free as in freedom. Not free as in beer.';

  /* 6. Shake a phone: you shook the packet. */
  if('DeviceMotionEvent' in window){
    var last=0,hits=0;
    window.addEventListener('devicemotion',function(e){
      var a=e.accelerationIncludingGravity;if(!a)return;
      var g=Math.abs(a.x||0)+Math.abs(a.y||0)+Math.abs(a.z||0);
      var now=Date.now();
      if(g>32&&now-last>120){hits++;last=now;if(hits>=3){hits=0;burst();say('You shook the packet.');}}
      if(now-last>1500)hits=0;
    });
  }

  /* 7. Ninety seconds idle: a nudge. */
  var chip=document.getElementById('season-chip'),idleT,idleOrig;
  if(chip){
    var span=chip.querySelector('span');
    var arm=function(){clearTimeout(idleT);if(idleOrig!==undefined){span.textContent=idleOrig;idleOrig=undefined;}
      idleT=setTimeout(function(){idleOrig=span.textContent;span.textContent='Still here? The soil won’t prep itself.';},90000);};
    ['scroll','mousemove','keydown','touchstart','click'].forEach(function(ev){window.addEventListener(ev,arm,{passive:true});});
    arm();
  }
})();
